export interface MediaState {
    isLoading: boolean;
    error: string;
}

export const initialMediaState: MediaState = {
    isLoading: false,
    error: null,
};
